<template>
  <div class="animated fadeIn">
    <basic-heading title="Staff" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list staff'">
      <template #gated-content>
        <staff-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import StatisticTile from "@/components/shared/StatisticTile";
import StaffServerTable from "@/components/lab/staff/StaffServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "StaffIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    StatisticTile,
    StaffServerTable,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/staff/add",
            title: "Add Staff",
            variant: "success",
            permission: this.checkPermission("add staff"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
